import React from 'react';
import PropTypes from 'prop-types';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import Content from './Content';

const ScenarioActivationQuestionStepTemplate = ({
  resource,
}) => {
  return (
    <WizardStepWrapperTemplate
      layout={Content}
      LayoutProps={{
        resource,
      }}
      resource={resource}
    />
  );
};

ScenarioActivationQuestionStepTemplate.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default ScenarioActivationQuestionStepTemplate;
